import React from 'react';
import { Box, Typography } from '@availity/element';
import availityIcon from '../../static/assets/icons/Vector.svg';
import footerDivider from '../../static/assets/icons/Divider.svg';
import footerDivider1 from '../../static/assets/icons/Divider-1.svg';
import { redirectToLogin } from '../../auth/authUtils';

interface FooterColumnProps {
  title: string;
  links: { text: string; url?: string; onClick?: () => void }[];
}

const FooterColumn: React.FC<FooterColumnProps> = ({ title, links }) => (
  <Box className="footer__column">
    <Typography className="footer__column-title">{title}</Typography>
    <Box className="footer__column-links">
      {links.map((link) => (
        <Typography
          key={link.text}
          component={link.url ? 'a' : 'button'}
          href={link.url}
          target={link.url ? '_blank' : undefined}
          rel={link.url ? 'noopener noreferrer' : undefined}
          onClick={link.onClick}
          className={`footer__link${!link.url && link.onClick ? ' footer__link--button' : ''}`}
        >
          {link.text}
        </Typography>
      ))}
    </Box>
  </Box>
);

const SEPARATOR = ' \u00A0|\u00A0 ';

const Footer: React.FC = () => (
  <Box className="footer">
    <Box className="footer__content">
      <Box className="footer__description">
        Availity is the place where healthcare finds the answers needed to shift focus back to patient care. By solving the communication challenges between healthcare stakeholders, Availity creates a richer, more transparent exchange of information among health plans, providers, and technology partners. As the nation&apos;s largest health information network, Availity facilitates over 13 billion clinical, administrative, and financial transactions annually. The company&apos;s suite of dynamic products, built on a powerful, intelligent platform, enables real-time collaboration for success in a competitive, value-based care environment.
      </Box>

      <Box className="footer__divider footer__divider--desktop">
        <img src={footerDivider} alt="" />
      </Box>

      <Box className="footer__divider footer__divider--mobile">
        <img src={footerDivider1} alt="" />
      </Box>

      <Box className="footer__columns">
        <FooterColumn
          title="Availity"
          links={[
            { text: 'Portal Login', onClick: redirectToLogin },
            { text: 'Regulatory Compliance', url: 'https://www.availity.com/regulatory-compliance/' },
            { text: 'Responsible Disclosure', url: 'https://www.availity.com/vulnerability-disclosure-program/' },
          ]}
        />
      </Box>
    </Box>

    <Box className="footer__bottom">
      <img src={availityIcon} alt="Availity" className="footer__icon" />
      <Typography className="footer__copyright">
        <span>&#169; Copyright 2026 Availity, LLC. All rights reserved.</span>
        <span className="footer__copyright-separator">{SEPARATOR}</span>
        <span className="footer__copyright-links">Privacy Policy{SEPARATOR}Terms of Use</span>
      </Typography>
    </Box>
  </Box>
);

export default Footer;
